
nl.mediquest.be_my_coach_frontend.core.init();